import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

const Quote = ({
  content, who, active, position,
}) => (
  <div className={cn('quotes-widget__quote', {
    active,
    prev: position === -1,
    next: position === 1,
  })}
  >
    <div className="quotes-widget__quote-content">
      {content}
      {who && (
      <div className="quotes-widget__quote-who">
        {who}
      </div>
      )}
    </div>
  </div>
)

Quote.propTypes = {
  content: PropTypes.string,
  who: PropTypes.string,
  active: PropTypes.bool,
  position: PropTypes.number,
}

Quote.defaultProps = {
  content: '',
  who: '',
  active: false,
  position: 0,
}

export default Quote
